<ng-template [ngIf]="activeDashBoardId > 0">
  <dx-dashboard-control #dashboardControl class="full-width block full-vh-height" endpoint="/dashboard"
    dashboardId="{{activeDashBoardId}}" workingMode='ViewerOnly'>
  </dx-dashboard-control> 
</ng-template>
